import {
  Box,
  Button,
  ButtonGroup,
  CardHeader,
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography
} from "@material-ui/core";
import {
  AccessTime,
  ArrowDropDown,
  ArrowDropUp,
  Close,
  EventAvailable,
  LocalHospital,
  LocalPhone,
  Person,
  RoomOutlined
} from "@material-ui/icons";
import React, { Component } from "react";
import PropTypes from "prop-types";
import AnnulationRdv from "./AnnulationRdv";
import Moment from "moment";
import { connect } from "react-redux";
import {
  cancelAppointmentsSMS,
  saveReasonCanceledSMS,
  updateRdvSMS
} from "../../../utils/fetcher";
import { DateTime } from "luxon";
class DetailsRDV extends Component {
  state = {
    openModal: false,
    openModalStart: true,
    showDetails: false,
    cancelRdv: false
  };

  handleChangeDetailsRDV = () => {
    return this.setState({
      showDetails: !this.state.showDetails
    });
  };

  handleShowDetails = state => {
    this.setState({ cancelRdv: state });
  };

  handleUpdateRdv = () => {
    this.props.onUpdateRdvSMS(this.props.rdv?.identifiant_rdv);
  };

  render() {
    const date_prise = DateTime.fromISO(this.props.rdv?.date_prise_rendez_vous)
      .setLocale("fr")
      .toFormat("EEEE dd MMMM yyyy");
    const heure_prise = Moment(
      this.props.rdv?.heure_debut_prise_rendez_vous,
      "HH:mm:ss"
    ).format("HH:mm");
    return (
      <>
        {/* Récap rdv sans connexion + détails - desktop */}
        {this.props.rdv && (
          <Box
            sx={{
              width: "100%",
              height: "35px",
              backgroundColor: "#19486D",
              borderRadius: "8px 8px 0 0",
              display: "flex",
              alignItems: "center"
            }}
          >
            <Typography
              style={{
                display: "flex",
                alignItems: "center",
                color: "white",
                fontSize: "14px",
                marginRight: 20,
                marginLeft: 8
              }}
            >
              <EventAvailable style={{ marginRight: 4, height: 18 }} />
              {date_prise}
            </Typography>

            <Typography
              style={{
                display: "flex",
                alignItems: "center",
                color: "white",
                fontSize: "14px"
              }}
            >
              <AccessTime style={{ marginRight: 4, height: 18 }} />
              {heure_prise}
            </Typography>
          </Box>
        )}
        <Box
          sx={{
            borderLeft: "1px solid #C8C8C8",
            borderRight: "1px solid #C8C8C8",
            borderBottom: "1px solid #C8C8C8",
            borderRadius: "0 0 8px 8px"
          }}
        >
          {!this.state.cancelRdv && this.props.rdv && (
            <List
              sx={{
                width: "100%",
                bgcolor: "background.paper"
              }}
            >
              <ListItem>
                <CardHeader
                  avatar={<img src="icons/avatar_praticien.svg" alt="icon" />}
                  title={`${this.props.rdv.docteurcivilite} ${
                    this.props.rdv.prenomdocteur
                  } ${this.props.rdv.nomdocteur}`}
                  subheader="Ophtalmologiste"
                  style={{
                    color: "black",
                    padding: 0
                  }}
                />
              </ListItem>

              <Divider variant="middle" component="li" />

              <ListItem>
                <ListItemText
                  primary={
                    <React.Fragment>
                      <Typography
                        style={{
                          display: "flex",
                          alignItems: "center",
                          color: "#212121",
                          fontSize: "14px",
                          marginRight: 20,
                          marginLeft: 8
                        }}
                      >
                        <Person
                          style={{
                            marginRight: 8
                          }}
                        />
                        {`${this.props.rdv.patiencivilite} ${
                          this.props.rdv.nompatient
                        } ${this.props.rdv.prenompatient}`}
                      </Typography>
                    </React.Fragment>
                  }
                  style={{
                    color: "#212121",
                    fontSize: "16px"
                  }}
                />
                <Button
                  onClick={this.handleChangeDetailsRDV}
                  aria-expanded={this.state.showDetails}
                  aria-label="show more"
                  style={{
                    backgroundColor: "transparent",
                    fontSize: "12px",
                    border: 0,
                    boxShadow: "none",
                    color: "#009EFF",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    textTransform: "none"
                  }}
                  endIcon={
                    this.state.showDetails ? <ArrowDropUp /> : <ArrowDropDown />
                  }
                >
                  Détails RDV
                </Button>
              </ListItem>
              {this.state.showDetails ? (
                <Divider variant="middle" component="li" />
              ) : (
                ""
              )}
              <ListItem
                style={{
                  display: `${this.state.showDetails ? "block" : "none"}`
                }}
                sx={{
                  "& > :not(style)": {
                    display: "flex",
                    justifyContent: "space-around",
                    height: 120,
                    width: 250
                  }
                }}
              >
                <Collapse
                  in={this.state.showDetails}
                  timeout="auto"
                  unmountOnExit
                >
                  <ListItem
                    style={{
                      color: "black",
                      padding: 0
                    }}
                  >
                    <ListItemIcon>
                      <img src="icons/Groupe37.svg" alt="icon" />
                    </ListItemIcon>
                    <ListItemText
                      primary={this.props.rdv.nom_lieux}
                      style={{
                        color: "#212121",
                        fontSize: "14px"
                      }}
                    />
                  </ListItem>
                  <ListItemText
                    primary={
                      <React.Fragment>
                        <Typography
                          style={{
                            display: "flex",
                            alignItems: "center",
                            color: "#212121",
                            fontSize: "12px",
                            marginRight: 20,
                            marginLeft: 8
                          }}
                        >
                          <LocalHospital
                            style={{
                              marginRight: 8
                            }}
                          />
                          Consultation
                        </Typography>
                      </React.Fragment>
                    }
                  />
                  <ListItemText
                    primary={
                      <React.Fragment>
                        <Typography
                          style={{
                            display: "flex",
                            alignItems: "center",
                            color: "#212121",
                            fontSize: "12px",
                            marginRight: 20,
                            marginLeft: 8
                          }}
                        >
                          <RoomOutlined
                            style={{
                              marginRight: 8
                            }}
                          />
                          {`${this.props.rdv.adresse_lieux} ${
                            this.props.rdv.ville_lieux
                          }`}
                        </Typography>
                      </React.Fragment>
                    }
                    style={{
                      color: "#212121",
                      fontSize: "12px"
                    }}
                  />

                  <ListItemText
                    primary={
                      <React.Fragment>
                        <Typography
                          style={{
                            display: "flex",
                            alignItems: "center",
                            color: "#212121",
                            fontSize: "12px",
                            marginRight: 20,
                            marginLeft: 8
                          }}
                        >
                          <LocalPhone
                            style={{
                              marginRight: 8
                            }}
                          />
                          05 05 05 05 05
                        </Typography>
                      </React.Fragment>
                    }
                    style={{
                      color: "#212121",
                      fontSize: "12px"
                    }}
                  />
                </Collapse>
              </ListItem>
            </List>
          )}

          {this.state.cancelRdv && (
            <AnnulationRdv
              handleShowRdvButton={this.props.handleShowRdvButton}
              selectedRdv={this.props.selectedRdv}
              onPrevStep={this.handleShowDetails}
              onCancel={this.props.onCancelRdv}
              onSaveReason={this.props.onSaveReasonRdv}
              validations={{ confirmation: true }}
            />
          )}

          {!this.state.cancelRdv && this.props.rdv && (
            <ButtonGroup
              disableElevation
              variant="contained"
              aria-label="Disabled elevation buttons"
              style={{
                width: "100%",
                borderRadius: "0 0 8px 8px",
                borderTop: "1px solid #C8C8C8"
              }}
            >
              <Button
                startIcon={<img src="icons/editRDV.svg" alt="icon" />}
                style={{
                  width: "100%",
                  color: "#009EFF",
                  backgroundColor: "white",
                  borderRadius: "0 0 0 8px",
                  textTransform: "none",
                  fontSize: "14px"
                }}
                onClick={this.handleUpdateRdv}
              >
                Modifier RDV
              </Button>
              <Button
                startIcon={<Close />}
                style={{
                  width: "100%",
                  color: "#009EFF",
                  backgroundColor: "white",
                  borderRadius: "0 0 8px 0",
                  textTransform: "none",
                  fontSize: "14px"
                }}
                onClick={() => this.handleShowDetails(true)}
              >
                Annuler RDV
              </Button>
            </ButtonGroup>
          )}
        </Box>
      </>
    );
  }
}

DetailsRDV.propTypes = {
  handleShowRdvButton: PropTypes.func,
  selectedRdv: PropTypes.any,
  dataSource: PropTypes.any,
  rdv: PropTypes.any,
  onCancelRdv: PropTypes.any,
  onUpdateRdvSMS: PropTypes.any,
  onSaveReasonRdv: PropTypes.any
};

const mapStateToProps = state => {
  return {
    dataSource: state.dataSource,
    activeStep: state.activeStep,
    isShowLinkPriorityCode: state.configuration.baffcodeprioritaire,
    typeConsultation: state.returnedValue.typeConsultation,
    isFromAdmin: state.returnedValue.from,
    messageWithCode: state.messageWithCode
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onCancelRdv: (rdv_id, cookie) =>
      dispatch(cancelAppointmentsSMS(rdv_id, cookie)),
    onSaveReasonRdv: (rdv_id, id_reason, description) =>
      dispatch(saveReasonCanceledSMS(rdv_id, id_reason, description)),
    onUpdateRdvSMS: rdv_id => dispatch(updateRdvSMS(rdv_id))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DetailsRDV);
